import { CleanCardDescription } from './CleanCardDescription';
import { CleanCardTitle } from './CleanCardTitle';
import { CleanCardRoot } from './CleanCardRoot';
import { CleanCardRating } from './CleanCardRating';

export const CleanCard = {
  Root: CleanCardRoot,
  Description: CleanCardDescription,
  Title: CleanCardTitle,
  Rating: CleanCardRating,
};
